import { GET_TOOLTIP_INFO } from '../../constants/actions/policy';

export function getTooltipInfo(payload) {
    return {
        type: GET_TOOLTIP_INFO,
        payload,
    };
}
